import PropTypes from "prop-types"
import { Modal, Pane } from "components/ui"
import { StackView } from "@planningcenter/tapestry-react"
import pcoUrl from "@planningcenter/url"
import ManageCategories from "components/admin/manage_categories"

const BlankStateCampusCategory = ({
  isOrgAdmin,
  useOrgMissingBlankState,
  useEventMissingBlankState,
  onModalChange,
  onModalClose,
  isAdmin
}) => {
  return (
    <Pane.BlankState>
      {useOrgMissingBlankState ? (
        <>
          You can use categories and campuses to help find signups more easily on Church Center. To
          get started, you can{" "}
          {isAdmin ? (
            <>add a category in Registrations</>
          ) : (
            <>
              ask an Administrator to add a category to your organization&apos;s Registrations
              settings
            </>
          )}{" "}
          or {isOrgAdmin && <>add a campus to your organization&apos;s account settings.</>}
          {!isOrgAdmin && (
            <>
              ask an Organization Administrator to add a campus to your organization&apos;s account
              settings.
            </>
          )}
          <StackView alignment="center" axis="horizontal" spacing={1} marginTop={1}>
            <>
              {isAdmin && (
                <Modal
                  triggerText="Add a category"
                  headerText="Categories"
                  onConfirmClick={onModalClose}
                  confirmButtonText="Done"
                  confirmButtonProps={{ theme: "flat", size: "md" }}
                  triggerProps={{ className: "", theme: "app", size: "sm" }}
                >
                  <ManageCategories afterChange={onModalChange} />
                </Modal>
              )}
              {isOrgAdmin && (
                <a
                  href={`${pcoUrl(window.railsEnv)("accounts")}/organization/campuses`}
                  className="btn-outline sm"
                >
                  Add a campus
                </a>
              )}
            </>
          </StackView>
        </>
      ) : (
        <>
          {useEventMissingBlankState && (
            <>
              You can assign this signup to categories and campuses so people can find it more
              easily on Church Center.
            </>
          )}
        </>
      )}
    </Pane.BlankState>
  )
}

BlankStateCampusCategory.propTypes = {
  isOrgAdmin: PropTypes.bool,
  useOrgMissingBlankState: PropTypes.bool,
  useEventMissingBlankState: PropTypes.bool,
  onIsEditing: PropTypes.func,
  onModalChange: PropTypes.func,
  onModalClose: PropTypes.func,
  isAdmin: PropTypes.bool
}

export default BlankStateCampusCategory
